import ExcelJS from "exceljs";
import {saveAs} from 'file-saver';
import DrawExcel from "@/commonFuncion/DrawExcel";

export async function exportToExcelStatistics(exportToExcelData, listDataExportExcel, typeSheet) {

    const fileName = exportToExcelData.nameFile;
    const workbook = new ExcelJS.Workbook();
    const sheetName = "ONEKIDS"

    await addDataList(workbook, sheetName, listDataExportExcel, typeSheet);

    // Dữ liệu truyền vào từ component
    async function addDataList(workbook, sheetName) {
        const titleFile = exportToExcelData.titleFile;
        let columnHeaders = []
        if (typeSheet === 'day') {
            columnHeaders = [
                'STT', 'Ngày', 'Số lượng giao dịch vào', 'Số lượng giao dịch ra',
                'Tổng số lượng giao dịch'
            ]
        } else {
            columnHeaders = [
                'STT', 'Tháng', 'Số lượng giao dịch vào', 'Số lượng giao dịch ra',
                'Tổng số lượng giao dịch'
            ]
        }
        // const columnHeaders = exportToExcelData.columnHeaders;
        const companyInfo = exportToExcelData.companyInfo;
        const columnWidths = exportToExcelData.columnWidths;
        let dataList = []
        dataList = await getDataTable(sheetName, listDataExportExcel, typeSheet)
        // const fileName = exportToExcelData.nameFile;
        //
        // const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(sheetName);

        await DrawExcel.drawColumnWidths(columnWidths, worksheet);

        await DrawExcel.drawCompanyInfo(companyInfo, worksheet);
        await DrawExcel.drawTitleRowNew(titleFile, worksheet);
        worksheet.addRow([]);
        await DrawExcel.drawTableHeadersStatistics(columnHeaders, worksheet);
        await DrawExcel.drawTableStatistics(dataList, worksheet);
        let otherObject = []
        otherObject = await calculateTotalMoney(sheetName, listDataExportExcel)
        await DrawExcel.drawTotalDataStatistics(otherObject, worksheet);
    }

    async function getDataTable(sheetName, listDataExportExcel) {
        let dataList = []
        for (let i = 0; i < listDataExportExcel.length; i++) {
            dataList.push(listDataExportExcel[i])
        }
        return dataList.map((x, index) => [
            index + 1,
            x.label,
            x.totalTransactionMoneyIn,
            x.totalTransactionMoneyOut,
            x.totalTransaction,
        ]);


    }

    async function calculateTotalMoney(sheetName, listDataExportExcel) {
        let dataList = []
        for (let i = 0; i < listDataExportExcel.length; i++) {
            dataList.push(listDataExportExcel[i])
        }
        let a1 = 0;
        let a2 = 0;
        let a3 = 0;
        for (let i = 0; i < dataList.length; i++) {
            a1 += dataList[i].totalTransactionMoneyIn;
            a2 += dataList[i].totalTransactionMoneyOut;
            a3 += dataList[i].totalTransaction;
        }
        return ['Tổng cộng', '', a1, a2, a3];
    }

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], {type: 'application/octet-stream'}), fileName + '.xlsx');

}

